import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

import type { AuditSearch } from '@/components/audit/audit-search-schema'
import { AuditWorkspace } from '@/components/audit/audit-workspace'
import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'

export const Route = createFileRoute('/_app/clients/$clientId/journal')({
  component: ClientJournalPage,
})

/**
 * Le journal du client (#216, « Journal » depuis #285) : les mêmes filtres et
 * libellés que l'écran Audit, le client imposé, les filtres locaux.
 */
function ClientJournalPage() {
  const client = useShellClient()
  const [filters, setFilters] = useState<AuditSearch>({})
  return (
    <Frame>
      <AuditWorkspace
        search={filters}
        fixedClient={client.id}
        onSearchChange={(next) => {
          setFilters((current) => ({ ...current, ...next }))
        }}
      />
    </Frame>
  )
}
